/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresUpdate } from "../../funcs/llmVectorStoresUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ModifyVectorStoreRequest$inboundSchema,
};

export const tool$llmVectorStoresUpdate: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-update",
  description: `Modify a vector store

Updates the properties of an existing vector store.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
